import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OptimaxService} from '../../../mailing/shared/services/optimax.service';
import {Router} from '@angular/router';
import {AlertService} from '../../services/alert.service';
import {TRANSLATE} from '../../classes/translatable';
import { ConfigurationService } from '../../../configuration/shared/services/configuration.service';
import { Configuration } from '../../../configuration/shared/classes/configuration';

@Component({
    selector: 'app-optimax-login',
    templateUrl: './optimax-login.component.html',
    styleUrls: ['./optimax-login.component.css']
})
export class OptimaxLoginComponent implements OnInit {
    @Input()    isGlobalOptimax = false;
    @Output()   authSuccess = new EventEmitter();

    users: any[];
    userId: number;
    currentUser: any;
    enableCreation: boolean;
    libelleCreation: string;
    enableAuthorization: boolean;
    authorizationStep: number;
    urlAuthorization: string;
    connectedUserIsAdmin: boolean;
    passerelles = [
        {value: 'msoffice', libelle: 'Microsoft (Outlook 365)', desabale: false},
        {value: 'ms', libelle: 'Microsoft (Outlook live)', desabale: true}, //TODO
        {value: 'google', libelle: 'Google (Gmail)', desabale: true}, //TODO
    ];
    selectedPasserelle: string;
    configuration: Configuration;

    constructor(
        private mailingService: OptimaxService,
        private router: Router,
        private alertService: AlertService,
        private configService: ConfigurationService
    ) { }

    ngOnInit() {
        this.getConfiguration();
        if (this.isGlobalOptimax)
            this.getGlobalUserOptimax();
        else
            this.getUsersOptimax();
    }

    getConfiguration() {
        this.configService.getConfiguration().subscribe( result => {
            if (result.status == 200) {
                this.configuration = new Configuration(result.data);
                if (this.configuration.giorgetti_optimax != null)  {
                    this.passerelles.push({value: 'giorgetti', libelle: 'Giorgetti Sharepoint', desabale: false},);
                }
            };
        })
    }

    private injectGlobalPrefix(str) {
        if (!this.isGlobalOptimax)
            return str;
        return 'global_' + str;
    }

    private setLocalStorage(id, data) {
        localStorage.setItem(this.injectGlobalPrefix(id), data);
    }

    private deleteLocalStorage(id) {
        localStorage.removeItem(this.injectGlobalPrefix(id));
    }

    private getLocalStorage(id) {
        return localStorage.getItem(this.injectGlobalPrefix(id));
    }

    getGlobalUserOptimax() {
        this.users = [];
        this.mailingService.getGlobaleUsersOptimax()
            .subscribe(retour => {
                if (retour.status === 200) {
                    retour.data.forEach(element => {
                        this.users.push(element);
                        if (element.rox_defaut === '1') {
                            this.userId = element.rox_id;
                            this.currentUser = element;
                        }
                    });
                    if (!this.currentUser && this.users.length > 0) {
                        this.userId = this.users[0].rox_id;
                        this.currentUser = this.users[0];
                    }
                } else {
                    this.alertService.error(retour.message);
                }
            });
    }

    getUsersOptimax() {
        this.users = [];
        this.mailingService.getUsersOptimax()
            .subscribe(retour => {
                if (retour.status === 200) {
                    retour.data.forEach(element => {
                        this.users.push(element);
                        if (element.rox_defaut === '1') {
                            this.userId = element.rox_id;
                            this.currentUser = element;
                        }
                    });
                    if (!this.currentUser && this.users.length > 0) {
                        this.userId = this.users[0].rox_id;
                        this.currentUser = this.users[0];
                    }
                } else {
                    this.alertService.error(retour.message);
                }
            });
    }

    enableUserCreation() {
        this.enableCreation = true;
    }

    discardUserCreation() {
        this.enableCreation = false;
        this.libelleCreation = null;
    }

    createUserOptimax() {
        this.mailingService.createUser(this.libelleCreation, this.isGlobalOptimax)
            .subscribe(retour => {
                if (retour.status === 200) {
                    if (retour.data) {
                        retour.data.forEach(element => {
                            this.users.push(element);
                            this.userId = element.rox_id;
                            this.currentUser = element;
                        });
                        this.enableCreation = false;
                    }
                } else {
                    this.alertService.error(retour.message);
                }
            });
    }

    authorizeOptimax() {
        this.urlAuthorization = null;
        if (this.selectedPasserelle) {
            const type = (this.selectedPasserelle === 'msoffice' ? 'office' : null);
            const passerelle = (this.selectedPasserelle === 'msoffice' ? 'ms' : this.selectedPasserelle);
            this.mailingService.getUrlAuthorization(passerelle, this.getLocalStorage('optimaxToken'), type)
                .subscribe(retour => {
                    if (retour.status === 200) {
                        if (retour.data.redirectUrl) {
                            this.authorizationStep = 2;
                            this.urlAuthorization = retour.data.redirectUrl;
                            window.open(retour.data.redirectUrl);
                        }
                    } else {
                        this.alertService.error(retour.message);
                    }
                });
        }
    }

    checkAuthSuccess() {
        this.mailingService.checkUserApi(this.getLocalStorage('optimaxToken'))
            .subscribe(retour => {
                if (retour.status === 200) {
                    if (retour.data.optimaxToken && retour.data.hasApi && retour.data.hasToken) {
                        this.setLocalStorage('optimaxHasApi', retour.data.hasApi);
                        this.setLocalStorage('optimaxApiType', retour.data.apiType);
                        this.authSuccess.emit();

                        this.mailingService.getComposeEmailUrl('compose')
                            .subscribe(result => {
                                if (result.status === 200) {
                                    if (result.data.url) {
                                        this.setLocalStorage('optimaxComposeUrl', result.data.url);
                                    }
                                } else {
                                    this.alertService.error(result.message);
                                    this.cancelAuthorization();
                                }
                            });
                    } else {
                        this.authorizationStep = 1;
                        this.alertService.error(TRANSLATE('Erreur lors de l\'autorisation, veuillez réessayer'));
                    }
                } else {
                    this.alertService.error(retour.message);
                }
            });
    }

    connectOptimax() {
        if (this.userId) {
            this.mailingService.connectOptimax(this.userId)
                .subscribe(retour => {
                    if (retour.status === 200) {
                        this.setLocalStorage('optimaxUser', retour.data.rox_id);
                        if (retour.data.optimaxToken && retour.data.hasApi) {
                            this.setLocalStorage('optimaxToken', retour.data.optimaxToken);
                            this.setLocalStorage('optimaxHasApi', retour.data.hasApi);
                            this.setLocalStorage('optimaxApiType', retour.data.apiType);

                            this.mailingService.getComposeEmailUrl('compose')
                                .subscribe(result => {
                                    if (result.status === 200) {
                                        if (result.data.url) {
                                            this.setLocalStorage('optimaxComposeUrl', result.data.url);
                                            this.alertService.success(TRANSLATE('Connexion autorisée'));
                                            this.authSuccess.emit();
                                        }
                                    } else {
                                        this.alertService.error(result.message);
                                        this.cancelAuthorization();
                                    }
                                });

                        } else if (retour.data.optimaxToken && !retour.data.hasApi) {
                            this.setLocalStorage('optimaxToken', retour.data.optimaxToken);
                            this.enableAuthorization = true;
                            this.authorizationStep = 1;
                            if (this.passerelles.length > 0) {
                                this.selectedPasserelle = this.passerelles[0].value;
                            }
                        }
                    } else {
                        this.alertService.error(retour.message);
                    }
                });
        }
    }

    cancelAuthorization() {
        this.deleteLocalStorage('optimaxUser');
        this.deleteLocalStorage('optimaxToken');
        this.deleteLocalStorage('optimaxHasApi');
        this.deleteLocalStorage('optimaxApiType');
        this.deleteLocalStorage('optimaxComposeUrl');
        this.enableAuthorization = false;
        this.authorizationStep = null;
        this.selectedPasserelle = null;
    }
}
